const generateBlockId = () => {
  let dt = new Date().getTime()
  return 'bxxxyxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0
    dt = Math.floor(dt / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

const defaultFontFamily = 'Arial'

const defaultPadding = {
  top: 20,
  bottom: 20,
}

const defaultHeadingPadding = {
  top: 20,
  bottom: 20,
}

export default {
  body: {
    id: 'body',
    type: 'body',
    config: {
      fontFamily: defaultFontFamily,
      colors: {
        canvas: '#FFF',
        backdrop: '#98BFC7',
      },
    },
  },
  rows: [
    {
      id: generateBlockId(),
      type: 'heading',
      content: '<h1>This a new template</h1>',
      config: {
        fontFamily: defaultFontFamily,
        fontSize: 32,
        padding: defaultHeadingPadding,
        colors: {
          text: '#f96c6c',
          links: '#ff366e',
          blockBackground: '',
        },
      },
    },
    {
      id: generateBlockId(),
      type: 'image',
      config: {
        image: null,
        link: '',
        alignment: 'center',
        fullWidth: false,
        padding: defaultPadding,
        colors: {
          blockBackground: '',
        },
      },
    },
    {
      id: generateBlockId(),
      type: 'paragraph',
      content:
        '<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.</p><p>Donec pede justo, <a href="https://jamp.ink/">this is a link</a>, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet.</p>',
      config: {
        fontFamily: defaultFontFamily,
        fontSize: 15,
        padding: defaultPadding,
        colors: {
          text: '#333b46',
          links: '#ec3167',
          blockBackground: '',
        },
      },
    },
    {
      id: generateBlockId(),
      type: 'button',
      content: '<p style="text-align:center;">Add button text</p>',
      config: {
        link: '',
        fontFamily: defaultFontFamily,
        fontSize: 18,
        alignment: 'center',
        shape: 'round',
        padding: defaultPadding,
        colors: {
          text: '#fffbe7',
          button: '#ff6969',
          border: '#dc5a5a',
          blockBackground: '#ffeaee',
        },
      },
    },
  ],
}
